import {GA4_TRACKING_ID} from '@/Utils/Constants';
import {clarity} from 'react-microsoft-clarity';

export const loadExternalScripts = () => {
  // Load GA4 Script
  const loadGA4 = () => {
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_TRACKING_ID}`;
    script.async = true;
    document.head.appendChild(script);

    // Define window.gtag + dataLayer synchronously (the canonical gtag snippet).
    // Previously `gtag` was a local function inside script.onload and was never
    // assigned to window, so window.gtag stayed undefined — every
    // event()/pageview()/setUserProperties() call (and the OrderSummary
    // conversion events) silently failed, and only the auto page_view from the
    // config push reached GA. Defining it on window (and before the async lib
    // loads) queues calls into dataLayer, which gtag.js drains on load.
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', GA4_TRACKING_ID);
  };

  // Load Clarity Script
  const loadClarity = () => {
    const script = document.createElement('script');
    script.src = 'https://www.clarity.ms/tag/klpl77glsk'; // Replace with your actual Clarity tracking ID
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      window.clarity =
        window.clarity ||
        function () {
          (window.clarity.q = window.clarity.q || []).push(arguments);
        };
      clarity('js', new Date());
    };
  };
  clarity.init('klpl77glsk');

  loadGA4();
  // loadClarity();
};
